import { Check } from '@mui/icons-material';
import { Button } from '@mui/material';
import { t } from 'i18next';
import { ProfileStore } from '../store/ProfileStore';

type Props = {
  store: ProfileStore;
  onClick: () => void;
};

export const SaveButton = ({ onClick, store }: Props) => {
  const enabled = store.isSaveEnabled();

  return (
    <Button variant="contained" startIcon={<Check />} disabled={!enabled} onClick={onClick}>
      {t('save')}
    </Button>
  );
};
